import { ORDER_METHODS } from '../services/exports/Constants';
import { Modifier, ProductInterface } from '../services/exports/Interfaces';

/**
 * A menu entry (product or modifier) is hidden when the selected order method's channel flag is
 * explicitly false. Visibility is already enforced server-side, so only the channel flag matters.
 * Non channel-bound methods (dine-in, room service, none) never hide an entry.
 */
export function isEntryAvailableForChannel(entry: ProductInterface | Modifier | undefined, method?: string): boolean {
  if (!entry) {
    return false;
  }

  const field =
    method === ORDER_METHODS.PICKUP
      ? 'is_available_for_pickup'
      : method === ORDER_METHODS.DELIVERY
        ? 'is_available_for_delivery'
        : null;

  if (!field) {
    return true;
  }

  return entry[field] !== false;
}
